<template>
  <div class="mb-20 d-flex flex-column flex-lg-row align-items-baseline justify-content-between letter-spacing gap-1">
    <h1 class="mb-5 mb-sm-0 fw-bold text-black">{{ title ?? page }}</h1>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb mb-0 list-unstyled ps-0">
        <li class="breadcrumb-item">
          <router-link :to="root_url ?? '/'" class="text-decoration-none text-black">
            {{ root ?? 'Dashboard'}}
          </router-link>
        </li>
        <slot></slot>
        <li class="breadcrumb-item active" aria-current="page">
          {{ page }}
        </li>
      </ol>
    </nav>
  </div>
</template>

<style>
.breadcrumb-item a:hover {
  color: initial !important;
}
</style>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "FKBreadCrumb",
  props: ["page", "title", "root", "root_url"],
});
</script>